import axios from "axios";
import AxiosClient from "../../services/axios.services";

class MunicipalityUserServices {
  getMunicipalitiessUser = params =>
    AxiosClient.get("/api/app/head_clima_municipio/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getMunicipalityUser = id =>
    AxiosClient.get(`/api/app/head_clima_municipio/?tipo_busqueda=departamento_id&filter=${id}`, {
      headers: { "Content-Type": "application/json" },
    });
  saveMunicipalityUser = data =>
    AxiosClient.post("/api/app/head_clima_municipio/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editMunicipalityUser = (id, data) =>
    AxiosClient.put(
      `/api/app/head_clima_municipio/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteMunicipalityUser = id =>
    AxiosClient.delete(`/api/app/head_clima_municipio/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new MunicipalityUserServices();